var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5469 10.3339C3.02372 13.7306 6.93727 15.3551 10.3339 13.8783C13.7306 12.4015 15.3551 8.48792 13.8783 5.09125C12.4015 1.69459 8.48792 0.0700932 5.09125 1.5469C1.69459 3.02372 0.0700932 6.93727 1.5469 10.3339Z",
    stroke: "#162056",
    strokeWidth: 2,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4014 12.4014L17.5702 17.5702",
    stroke: "#162056",
    strokeWidth: 2,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.caad341d2eb86fd0eaefe673e13fc834.svg";
export { ForwardRef as ReactComponent };